import { render, staticRenderFns } from "./DecisionModelos.vue?vue&type=template&id=145fdbea"
import script from "./DecisionModelos.vue?vue&type=script&lang=js"
export * from "./DecisionModelos.vue?vue&type=script&lang=js"
import style0 from "./DecisionModelos.vue?vue&type=style&index=0&id=145fdbea&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports